var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.06,17h0a1.26,1.26,0,0,0-.92.38,1.28,1.28,0,0,0-.38.92,1.3,1.3,0,1,0,1.3-1.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12.92a6.4,6.4,0,0,0-4.57,1.9l-.29.29L8.7,16.63l.3-.29a4.31,4.31,0,0,1,6.12,0l.29.3,1.53-1.53-.29-.29A6.46,6.46,0,0,0,12,12.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06,8.6a10.36,10.36,0,0,0-7.57,3.24l-.28.29,1.53,1.53L6,13.35a8.29,8.29,0,0,1,12.06,0l.29.31,1.53-1.53-.28-.29A10.39,10.39,0,0,0,12.06,8.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.76,8.7a15.33,15.33,0,0,0-21.4,0L1.06,9l1.52,1.53.3-.28a13.16,13.16,0,0,1,18.36,0l.29.28L23.06,9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionGood);
export default __webpack_public_path__ + "static/media/connection-good.da82c6a549569d9dcb21ae0c1a3f7b85.svg";
export { ForwardRef as ReactComponent };